import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CommonComponentsModule } from "src/app/common-components";
import { InfoportalApiContractFolderCreateDialogComponent } from "./contracts/contract-folder-create/contract-folder-create-dialog.component";
import { InfoportalApiContractFolderUpdateDialogComponent } from "./contracts/contract-folder-update/contract-folder-update-dialog.component";
import { InfoportalApiReceiptFolderCreateDialogComponent } from "./receipts/receipt-folder-create/receipt-folder-create-dialog.component";
import { InfoportalApiReceiptFolderUpdateDialogComponent } from "./receipts/receipt-folder-update/receipt-folder-update-dialog.component";

@NgModule({
  imports: [CommonModule, CommonComponentsModule],
  declarations: [
    InfoportalApiContractFolderCreateDialogComponent,
    InfoportalApiContractFolderUpdateDialogComponent,
    InfoportalApiReceiptFolderCreateDialogComponent,
    InfoportalApiReceiptFolderUpdateDialogComponent,
  ],
  exports: [
    InfoportalApiContractFolderCreateDialogComponent,
    InfoportalApiReceiptFolderCreateDialogComponent,
    InfoportalApiReceiptFolderUpdateDialogComponent,
  ],
})
export class InfoportalApiDialogsModule {}
